import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from './AuthProvider';

/** Every route except /login sits behind this — redirects when no valid session can be restored. */
export function RequireAuth() {
  const { status } = useAuth();
  const location = useLocation();

  if (status === 'loading') return <p>Loading…</p>;
  if (status === 'unauthenticated') return <Navigate to="/login" state={{ from: location }} replace />;
  return <Outlet />;
}
